/** Progress line for the tools the agent runs before answering (names only). */
import React from 'react';
import { Box, Text } from '@common-fe/common-fe';
import styled from 'styled-components';

import colors from '@/styles/colors';

import { TOOL_LABELS } from '../../assistant.constants';
import { ToolRun } from '../../assistant.types';

const Marker = styled.span<{ $done: boolean }>`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
  background: ${({ $done }) => ($done ? colors.success : colors.info)};
`;

interface Props {
  tools: ToolRun[];
}

const ToolProgress: React.FC<Props> = ({ tools }) => {
  if (!tools.length) return null;
  return (
    <Box gap="spacing4" margin={{ bottom: 'spacing8' }} data-testid="assistant-tool-progress">
      {tools.map((t, i) => (
        <Box
          key={`${t.tool}-${i}`}
          direction="row"
          align="center"
          gap="spacing6"
          style={{ opacity: t.done ? 0.65 : 1 }}
        >
          <Marker $done={t.done} />
          {/* An unknown tool still shows: better a raw name than a silent gap
              if the service gains a tool before this map does. */}
          <Text size="small" color="textSecondary">
            {TOOL_LABELS[t.tool] || t.tool}
            {t.done ? '' : '…'}
          </Text>
        </Box>
      ))}
    </Box>
  );
};

export default ToolProgress;
